<template>
    <div>
        <meetingReservationTable ref="leadOfficialTable" @viewObject="viewObject" @addNewForm="addNewForm" />
        <Basicform :title="$tx('hygl.hyyt.meetingLation', '会议室预定')" :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited" :append-to-body="true">
            <template #default="slotProps">
                <busi-form :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import meetingReservationTable from './components/meetingReservationTable'

const moment = require('moment')
export default {
    components: {
        meetingReservationTable
        // DateCalendar
    },
    props: {
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'portlet',
            moduleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=&url=/hygl/meeting/form.html',
                winWidth: 1000,
                delUrl: 'hygl/meeting/delete',
                addNewUrl: 'hygl/meeting/addNew',
                insertUrl: 'hygl/meeting/insert',
                moduleCode: 'meeting',
                winHeight: 600,
                listDataUrl: 'hygl/meeting/listdata',
                getByIdUrl: 'hygl/meeting/getById'
            },
            busiformBtns: [],
            rooms: {},
            cell: '',
            tankuang: [],
            dayNumber: 1,
            noticeArr: [],
            columndate: '', // 临时保存点击的日期
            ddian: ''
        }
    },
    computed: {
        ...mapGetters(['loginUser'])
    },
    watch: {},
    created() {
        console.log('appletData会议室预定', this.appletData)
        let formurl = this.moduleInfo.formTemplate.split('url=')[1]
        formurl = formurl.replace(/\//g, '.')
        formurl = '#/dcontent/vuebusiform/W/' + formurl.substring(1).replace('.html', '.vue')
        formurl += '?sysCode=' + (this.$route.meta.sysCode || '')
        this.$options.components['BusiForm'] = this.$loadComponent(formurl)
        this.$bus.emit('showNavSearch', false)
    },
    beforeDestroy() {
        this.$bus.emit('showNavSearch', true)
    },
    mounted() {
        this.SwiperGetDate(this.getThisWeek(0), this.getThisWeek(-6))
    },
    methods: {
        async addNewForm(row, column) {
            console.log(this, 'this')
            this.columndate = column.weekday
            this.ddian = row.site
            await this.selectRoom(row.id)
            if (this.rooms.approve === 0) {
                this.busiformBtns = [
                    {
                        id: 'btn_close',
                        btnName: '关 闭',
                        btnIcon: 'close',
                        btnClick: 'closeDialog',
                        btnPermissio: '',
                        btnType: ''
                    },
                    {
                        id: 'btn_save_applay',
                        btnName: '去申请',
                        btnIcon: 'check',
                        btnClick: 'submitBusiform',
                        btnPermission: '',
                        btnType: 'primary',
                        btnI18nCode: 'saveApplay'
                    }
                ]
            } else {
                this.busiformBtns = [
                    {
                        id: 'btn_close',
                        btnName: '关 闭',
                        btnIcon: 'close',
                        btnClick: 'closeDialog',
                        btnPermissio: '',
                        btnType: ''
                    },
                    {
                        id: 'btn_save',
                        btnName: '完成预定',
                        btnIcon: 'check',
                        btnClick: 'submitBusiform',
                        btnPermission: 'saveObject',
                        btnType: 'primary',
                        btnI18nCode: 'finishLation'
                    }
                ]
            }
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, null, 1)
            })
        },
        // 会议室信息查询
        selectRoom(roomID) {
            console.log(this.loginUser.orgCode)
            return new Promise((resolve, reject) => {
                this.$http({
                    method: 'POST',
                    url: 'hygl/meetingRoom/querydata',
                    contentType: 'application/x-www-form-urlencoded',
                    data: [
                        { compare: '=', field: 'id', merge: true, value: roomID },
                        {
                            compare: '=',
                            field: 'orgCode',
                            merge: true,
                            value: this.loginUser.orgCode
                        }
                    ]
                }).then((res) => {
                    if (res.code === 'success') {
                        this.rooms = res.body.listdata[0]
                        resolve(true)
                    }
                })
            })
        },
        // 查看
        async viewObject(vo) {
            this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermissio: '',
                    btnType: ''
                }
            ]
            await this.selectRoom(vo.meetRoomId)
            if (vo.preordainType === '1') {
                vo.id = vo.groupId
                this.moduleInfo.getByIdUrl = 'hygl/meeting/getByGroupId'
            } else {
                this.moduleInfo.getByIdUrl = 'hygl/meeting/getById'
            }

            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, vo, 0)
            })
        },
        /**
         * 表单打开检查，vo为已加载vote对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
         */
        onBasicFormBeforeOpen($scope, vo, defer) {
            // vo.site = this.rooms.site
            vo.site = this.ddian
            vo.meetRoomId = this.rooms.id
            vo.week = this.rooms.weekProperties
            vo.weeks = this.rooms.weekProperties
            vo.approve = this.rooms.approve
            vo.numPeople = this.rooms.numPeople
            vo.phone = this.loginUser.personMobile
            vo.meetName = this.rooms.meetName
            vo.canNumPeople = this.rooms.numPeople
            vo.remark = this.rooms.remark
            vo.applayName = this.loginUser.personName
            vo.applyUserid = this.loginUser.personId
            if (vo.beginTime === null || vo.endTime === null) {
                var kais = moment(this.rooms.beginTime).format('HH:mm')
                var jies = moment(this.rooms.endTime).format('HH:mm')
                vo.beginTime = this.columndate + ' ' + kais
                vo.endTime = this.columndate + ' ' + jies
            } else {
                var time1 = vo.beginTime.slice(0, 11)
                var time2 = vo.endTime.slice(0, 11)
                var date1 = vo.beginTime.slice(11, 16)
                var date2 = vo.endTime.slice(11, 16)
                this.$set(vo, 'time1', time1)
                this.$set(vo, 'time2', time2)
                this.$set(vo, 'date1', date1)
                this.$set(vo, 'date2', date2)
            }
            vo.createTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            vo.departmentUser = this.loginUser.staffList[0].orgFullName.split('-')[this.loginUser.staffList[0].orgFullName.split('-').length - 1]
            if (this.rooms.serviceProperties !== null) {
                const type = this.rooms.serviceProperties.split(',')
                const typeArray = []
                type.forEach((v) => {
                    typeArray.push({
                        text: v,
                        value: v
                    })
                })
                vo.passenger['servicePropertiesOptions'] = typeArray
            }
            if (this.rooms.weekProperties !== null) {
                const type = this.rooms.weekProperties.split(',')
                const typeArray = []
                type.forEach((v) => {
                    typeArray.push({
                        text: v,
                        value: v
                    })
                })
                vo.passenger['weekOptions'] = typeArray
            }
            if (this.rooms.deviceProperties !== null) {
                const type = this.rooms.deviceProperties.split(',')
                const typeArray = []
                type.forEach((v) => {
                    typeArray.push({
                        text: v,
                        value: v
                    })
                })
                vo.passenger['devicePropertiesOptions'] = typeArray
            }

            defer.resolve(true)
        },
        onBasicFormOpened($scope, vo) {
            console.log($scope, vo, 111)
        },

        // 表单提交事件，vo为待提交的对象，校验成功：defer.resolve(true)，校验失败：defer.reject(reason)
        // approve == 1 否， 0 是
        onBasicFormBeforeSubmit($scope, vo, defer) {
            vo.weekProperties = vo.weeks
            console.log('提交', vo)
            if (vo.approve !== 0) {
                vo.status = 1
            } else {
                vo.status = 2
            }
            if (vo.preordainType === '1' && vo.value2 && vo.value1) {
                vo.beginTime = vo.value2[0] + ' ' + vo.value1[0]
                vo.endTime = vo.value2[1] + ' ' + vo.value1[1]
            } else {
                //
            }
            // if (vo.preordainType === '0') {
            var stTime = moment(vo.beginTime).format('YYYY-MM-DD HH:mm')
            var stTime2 = moment(vo.beginTime).format('YYYY-MM-DD') + ' ' + this.rooms.beginTime.substr(11, 5)
            var enTime = moment(vo.endTime).format('YYYY-MM-DD HH:mm')
            var enTime2 = moment(vo.endTime).format('YYYY-MM-DD') + ' ' + this.rooms.endTime.substr(11, 5)
            stTime = new Date(stTime).getTime()
            stTime2 = new Date(stTime2).getTime()
            enTime = new Date(enTime).getTime()
            enTime2 = new Date(enTime2).getTime()

            const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
            const startWeekDay = weeks[new Date(vo.beginTime).getDay()]
            const endWeekDay = weeks[new Date(vo.endTime).getDay()]
            if (vo.preordainType === '0') {
                if (this.rooms.weekProperties.indexOf(startWeekDay) === -1 || this.rooms.weekProperties.indexOf(endWeekDay) === -1) {
                    this.$alert(this.$tx('hygl.message.meetingOpenIn2', { day: this.rooms.weekProperties }, `会议室开放周期为‘${this.rooms.weekProperties}’！请在开放周期内预定`), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                    defer.reject()
                    return
                }
            }

            if (stTime < stTime2 || enTime > enTime2 || stTime > enTime) {
                this.$alert(this.$tx('hygl.message.meetingOpenIn3', { day: this.rooms.beginTime.substr(11, 5) + ' - ' + this.rooms.endTime.substr(11, 5) }, `会议室开放时间为${this.rooms.beginTime.substr(11, 5) + ' - ' + this.rooms.endTime.substr(11, 5)}`), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                defer.reject()
                return
            }
            // }

            // if (new Date(vo.beginTime).getTime() < new Date(moment(new Date()).format('YYYY-MM-DD HH:mm')).getTime()) {
            //     this.$alert('会议室开始时间不能早于当前时间', this.$tx('common.operationTip','操作提示'), { type: 'warning' })
            //     defer.reject()
            //     return
            // }
            if (vo.beginTime > vo.endTime) {
                this.$alert(this.$tx('hygl.message.meetingBegin', '结束时间不能早于开始时间'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                defer.reject()
                return
            }
            // if (!vo.numPeople) {
            //     this.$message.error('参会人数是必须的！')
            //     defer.reject()
            // }
            if (vo.numPeople > vo.canNumPeople) {
                this.$message.error(this.$tx('hygl.message.meetingNumExceed', '不能超过会议室可容纳人数'))
                defer.reject()
                return
            }

            defer.resolve(true)
        },
        /**
         * 表单提交完成，vo为已保存成功的sysLog对象，窗口即将关闭，不需要返回值
         */
        onBasicFormSubmited($scope, vo) {
            if (process.env.NODE_ENV === 'development') console.log('sysLog form submited')
            this.$nextTick(() => {
                this.$bus.emit('refreshtable')
            })
            var time = moment(vo.beginTime).format('YYYY-MM-DD') + ' ' + moment(vo.beginTime).format('HH:mm') + '-' + moment(vo.endTime).format('HH:mm')
            this.tankuang.push({ timebegin: moment(vo.beginTime).format('HH:mm'), meetSubjedt: vo.meetSubjedt, meetName: vo.meetName, applayName: vo.applayName, phone: vo.phone, time: time })
            if (vo.approve === 0) {
                var url = '/#/wflow?wfEngineUrl=hygl/roomApply&busiCode=roomApply&wfName=会议室申请&startNodeName=&meetId=' + vo.id + '&type=' + vo.preordainType + ''
                window.open(url)
            }
        },
        // 取消通知滚动条获取数据
        SwiperGetDate(startTime, endTime) {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                data: [
                    {
                        compare: '>=',
                        field: 'cancelTime',
                        merge: false,
                        value: startTime
                    },
                    {
                        compare: '<=',
                        field: 'cancelTime',
                        merge: false,
                        value: endTime
                    },
                    {
                        compare: '=',
                        field: 'orgCode',
                        merge: true,
                        value: this.loginUser.orgCode
                    }
                ],
                url: '/hygl/meetingCancel/querydata'
            }).then((res) => {
                if (res.code === 'success') {
                    this.noticeArr = this.dellCancelNotice(res.body.listdata)
                    // this.noticeArr.forEach(item => {
                    //     this.SwiperNoticString += item.notice + '  '
                    // })
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 获取本周时间
        getThisWeek(n) {
            var now = new Date()
            var year = now.getFullYear()
            // 因为月份是从0开始的,所以获取这个月的月份数要加1才行
            var month = now.getMonth() + 1
            var date = now.getDate()
            var day = now.getDay()
            console.log(date)
            // 判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
            if (day !== 0) {
                n = n + (day - 1)
            } else {
                n = n + day
            }
            if (day) {
                // 这个判断是为了解决跨年的问题
                if (month <= 1) {
                    // 这个判断是为了解决跨年的问题,月份是从0开始的
                    year = year - 1
                    month = 12
                }
            }
            now.setDate(now.getDate() - n)
            year = now.getFullYear()
            month = now.getMonth() + 1
            date = now.getDate()
            const str = new Date(year + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date) + ' ' + '00:00:00')
            return str
        },
        dellCancelNotice(data) {
            data.forEach((item) => {
                // item.notice = ''
                // 周期
                if (item.preordainType === '1') {
                    // item.title = `从${new Date(item.beginTime).getFullYear()}年${new Date(item.beginTime).getMonth()}月${new Date(item.beginTime).getDate()}日开始，原定于每 ${item.week} ${new Date(item.beginTime).getHours()}:${new Date(item.beginTime).getMinutes()} 到 ${new Date(item.endTime).getHours()}:${new Date(item.endTime).getMinutes()} 的会议取消`
                    item.title = this.$tx(
                        'hygl.message.dellCancelNoticeTitle',
                        {
                            year: new Date(item.beginTime).getFullYear(),
                            month: new Date(item.beginTime).getMonth(),
                            day: new Date(item.beginTime).getDate(),
                            week: item.week,
                            hour: new Date(item.beginTime).getHours(),
                            min: new Date(item.beginTime).getMinutes(),
                            endhour: new Date(item.endTime).getHours(),
                            endMin: new Date(item.endTime).getMinutes()
                        },
                        `从${new Date(item.beginTime).getFullYear()}年${new Date(item.beginTime).getMonth()}月${new Date(item.beginTime).getDate()}日开始，原定于每 ${item.week} ${new Date(item.beginTime).getHours()}:${new Date(item.beginTime).getMinutes()} 到 ${new Date(item.endTime).getHours()}:${new Date(item.endTime).getMinutes()} 的会议取消`
                    )
                } else {
                    // item.title = `${item.applayName === this.loginUser.personName ? '您' : item.applayName}预订的${moment(item.beginTime).format('YYYY-MM-DD HH:mm')}到${moment(item.endTime).format('YYYY-MM-DD HH:mm')}时段的${item.meetName}已被${item.cancelUser === this.loginUser.personId ? '您' : item.cancelName}取消`
                    // item.title = `{name}预订的{time1}到{time2}时段的{meetName}已被{name2}取消`
                    item.title = this.$tx(
                        'hygl.message.dellCancelNoticeTitle2',
                        {
                            name: item.applayName === this.loginUser.personName ? '您' : item.applayName,
                            time1: moment(item.beginTime).format('YYYY-MM-DD HH:mm'),
                            time2: moment(item.endTime).format('YYYY-MM-DD HH:mm'),
                            meetName: item.meetName,
                            name2: item.cancelUser === this.loginUser.personId ? '您' : item.cancelName
                        },
                        `${item.applayName === this.loginUser.personName ? '您' : item.applayName}预订的${moment(item.beginTime).format('YYYY-MM-DD HH:mm')}到${moment(item.endTime).format('YYYY-MM-DD HH:mm')}时段的${item.meetName}已被${item.cancelUser === this.loginUser.personId ? '您' : item.cancelName}取消`
                    )
                }
            })
            return data
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-table tbody tr:hover > td {
    background-color: #ffffff !important;
}
.el-carousel__item {
    color: #e6a23c;
}
.el-carousel__item h3 {
    color: #e6a23c;
    font-size: var(--portalFontSize14);
    line-height: 30px;
    font-weight: 400;
    margin: 0;
}

.el-carousel__item {
    background-color: none;
}
/deep/.el-date-editor .el-range-separator {
    width: 8%;
}
</style>
